import React from 'react';
import { Reveal } from './Reveal';
import { Label } from './Label';
import { proof } from '../data/site';
export function Proof() {
  return <section id="background" className="relative w-full bg-cream py-24 sm:py-32" data-id="element-117" data-mp="7q1uh18aydhk">
      <div className="mx-auto max-w-[720px] px-5 sm:px-8" data-id="element-118" data-mp="lortwnilgp93">
        <Reveal data-id="element-119" data-mp="gr9imqh3txxx">
          <div className="flex items-center gap-3" data-id="element-120" data-mp="gqqau2l64pxm">
            <span className="h-px w-10 bg-copper" data-id="element-121" data-mp="gox4koegw7q5" />
            <Label data-id="element-122" data-mp="3p7uuqg519759">Background</Label>
          </div>
          <h2 className="mt-5 font-serif text-4xl italic leading-[1.06] text-navy sm:text-5xl" data-id="element-123" data-mp="3p4gp8z12ohtl">
            Between the model and the P&amp;L
          </h2>
        </Reveal>

        <div className="mt-14 flex flex-col gap-10 border-t border-navy/15 pt-12" data-id="element-124" data-mp="2sjj746tbm6e">
          {proof.map((item, i) => <Reveal key={item.title} delay={0.04 * i} className="flex flex-col border-b border-navy/12 pb-10 last:border-b-0 last:pb-0" data-id="element-125" data-mp="3u4341cwju64i" data-mpi={i}>
              <Label tone="navy" data-id="element-126" data-mp="31i0j21wg9oml">{item.label}</Label>
              <h3 className="mt-4 font-serif text-[1.75rem] italic leading-tight text-navy sm:text-3xl" data-id="element-127" data-mp="31f4j6811kpvi">
                {item.title}
              </h3>
              <p className="mt-4 font-sans text-base font-light leading-relaxed text-navy/65" data-id="element-128" data-mp="2dm0judh7l8jn">
                {item.body}
              </p>
              <span aria-hidden="true" className="mt-8 block h-px w-10 bg-copper/50" data-id="element-129" data-mp="2ifvc45avqvuc" />
            </Reveal>)}
        </div>
      </div>
    </section>;
}